// src/admin/AdminHeader.js
import React, { useContext, useState, useRef, useEffect } from "react";
import {
  FaBars,
  FaGlobe,
  FaBell,
  FaSearch,
  FaEye,
  FaEyeSlash,
  FaSignOutAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AdminLanguageContext } from "./context/AdminLanguageContext";
import AdminCommandPalette from "./components/AdminCommandPalette";
import { getAdminNotifications } from "../services/adminNotifications.api";
import { FaShoppingCart, FaBoxOpen, FaEnvelope } from "react-icons/fa";
import { getPendingOrdersCount } from "../services/adminOrders.api";

function AdminHeader({ setIsOpen, customCenter = null, beforeSearch = null }) {
  const { lang, toggleLanguage } = useContext(AdminLanguageContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);

  const [pendingOrders, setPendingOrders] = useState(0);

  const [commandOpen, setCommandOpen] = useState(false);

  const profileRef = useRef(null);
  const searchRef = useRef(null);

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");

  const username = adminUser.username || "User";
  const role = adminUser.role || "staff";
  const password = adminUser.password || "••••••";

  const avatarInitial = username.charAt(0).toUpperCase();

  const [bellOpen, setBellOpen] = useState(false);
const bellRef = useRef(null);

const [notificationCounts, setNotificationCounts] = useState({
  order: 0,
  stock: 0,
  message: 0
});


 useEffect(() => {

  const loadNotifications = () => {
  getAdminNotifications().then((rows) => {

    const order = rows.filter(
      (n) => n.type === "new_order" && !n.is_read
    ).length;

    const stock = rows.filter(
      (n) => n.type === "low_stock" && !n.is_read
    ).length;

    const message = rows.filter(
      (n) => n.type === "new_message" && !n.is_read
    ).length;

    setNotificationCounts({ order, stock, message });

  }).catch(() => {});

  // ✅ ADD THIS
  getPendingOrdersCount()
    .then((res) => setPendingOrders(res.count || 0))
    .catch(() => {});
};

  // initial load
  loadNotifications();

  // refresh every 60 seconds
  const interval = setInterval(loadNotifications, 60000);

  // cleanup when component unmounts
  return () => clearInterval(interval);

}, []);

  useEffect(() => {
  const handler = (e) => {
    const key = typeof e.key === "string" ? e.key.toLowerCase() : "";

    // Ctrl+K (English keyboard) OR Ctrl+ن (Arabic keyboard)
    if ((e.ctrlKey || e.metaKey) && (key === "k" || key === "ن")) {
      e.preventDefault();
      setCommandOpen(true);
    }
  };

  window.addEventListener("keydown", handler);

  return () => window.removeEventListener("keydown", handler);
}, []);

  // Close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
  const handler = (e) => {
    if (bellRef.current && !bellRef.current.contains(e.target)) {
      setBellOpen(false);
    }
  };

  document.addEventListener("mousedown", handler);
  return () => document.removeEventListener("mousedown", handler);
}, []);

  const totalNotifications =
  pendingOrders +
  notificationCounts.stock +
  notificationCounts.message;

  const TEXT = {
  EN: {
    dashboard: "Admin Dashboard",
    search: "Search (Ctrl + K)",
    username: "Username",
    password: "Password",
    role: "Role",
    logout: "Logout",
    admin: "Admin",
    staff: "Staff",

    notifications: "Notifications",
    orders: "Orders",
    stock: "Low Stock",
    messages: "Messages",
    noResults: "No results",
    viewAll: "View all notifications"
  },
  AR: {
    dashboard: "لوحة التحكم",
    search: "بحث (Ctrl + ن)",
    username: "اسم المستخدم",
    password: "كلمة المرور",
     noResults: "لا توجد نتائج",
    role: "الدور",
    logout: "تسجيل الخروج",
    admin: "مدير",
    staff: "موظف",

    notifications: "الإشعارات",
    orders: "الطلبات",
    stock: "المخزون المنخفض",
    messages: "الرسائل",
    viewAll: "عرض كل الإشعارات"
  },
}[lang];

  const pages = [

  /* DASHBOARD */

  { name: { EN: "Dashboard", AR: "لوحة التحكم" }, path: "/admin/dashboard" },

  /* ORDERS */

  { name: { EN: "Orders", AR: "الطلبات" }, path: "/admin/orders" },
  { name: { EN: "Abandoned Carts", AR: "السلال المتروكة" }, path: "/admin/abandoned-carts" },
  { name: { EN: "Shipping", AR: "الشحن" }, path: "/admin/shipping" },

  /* USERS */

  { name: { EN: "Users", AR: "المستخدمين" }, path: "/admin/users" },
  { name: { EN: "Customers", AR: "العملاء" }, path: "/admin/customers" },
  { name: { EN: "Customer Activity", AR: "نشاط العملاء" }, path: "/admin/users-activity" },

  /* PRODUCTS */

  { name: { EN: "Products", AR: "المنتجات" }, path: "/admin/products" },
  { name: { EN: "Categories", AR: "التصنيفات" }, path: "/admin/categories" },
  { name: { EN: "New In", AR: "الجديد" }, path: "/admin/products/new-in" },
  { name: { EN: "Bestsellers", AR: "الأكثر مبيعًا" }, path: "/admin/products/bestsellers" },
  { name: { EN: "On Sale", AR: "التخفيضات" }, path: "/admin/products/on-sale" },

  /* MARKETING */

  { name: { EN: "Promo Codes", AR: "أكواد الخصم" }, path: "/admin/email-templates" },
  { name: { EN: "Promo Banners", AR: "العروض الترويجية" }, path: "/admin/sale-banner" },

  /* ANALYTICS */

  { name: { EN: "Analytics", AR: "التحليلات" }, path: "/admin/analytics" },

  /* ALERTS */

  { name: { EN: "Inventory Alerts", AR: "تنبيهات المخزون" }, path: "/admin/inventory" },
  { name: { EN: "Notifications", AR: "الإشعارات" }, path: "/admin/notifications" },
  { name: { EN: "Messages", AR: "الرسائل" }, path: "/admin/messages" },

  /* SETTINGS */

  { name: { EN: "Settings", AR: "الإعدادات" }, path: "/admin/settings" },
  { name: { EN: "SEO Manager", AR: "إدارة SEO" }, path: "/admin/seo" },
  { name: { EN: "Email Templates", AR: "قوالب البريد" }, path: "/admin/email-template-manager" },
  { name: { EN: "Top Banner", AR: "الشريط العلوي" }, path: "/admin/top-banner" },

];

  const filteredPages = pages.filter((p) => {
  const name = p.name[lang] || p.name.EN;
  return name.toLowerCase().includes(search.toLowerCase());
});

  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    localStorage.removeItem("staffPermissions");
    navigate("/admin/login");
  };

  return (
   <>
    <header className="fixed top-0 left-0 w-full bg-[#1f1f1f] text-white h-[56px] flex items-center justify-between px-4 z-50">

      {/* LEFT */}
      <div className="flex items-center gap-3">
        <button
          className="lg:hidden text-xl text-gray-300 hover:text-white"
          onClick={() => setIsOpen(true)}
        >
          <FaBars />
        </button>

        <div className="hidden sm:block font-semibold text-[15px] tracking-wide">
          {TEXT.dashboard}
        </div>
      </div>

    {/* CENTER */}
<div className="flex-1 flex justify-center px-2 sm:px-6 min-w-0">

  {customCenter ? (
    customCenter
  ) : (
    <div className="flex items-center gap-2 w-full max-w-[620px] min-w-0">
      {beforeSearch && (
        <div className="shrink-0">
          {beforeSearch}
        </div>
      )}

      <div className="relative flex-1 min-w-0">

      <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />

          <input
  ref={searchRef}
  type="text"
  placeholder={TEXT.search}
  onClick={() => setCommandOpen(true)}
  readOnly
  className="
  w-full
  bg-[#2c2c2c]
  text-sm
  text-gray-200
  placeholder-gray-400
  rounded-md
  pl-9
  pr-3
  py-[6px]
  outline-none
  border border-[#3a3a3a]
  focus:border-[#6b6b6b]
  cursor-pointer
"
/>

          {search && (
            <div className="absolute top-[38px] w-full bg-white text-black rounded-md shadow-lg max-h-60 overflow-y-auto z-50">

              {filteredPages.length === 0 && (
                <div className="px-3 py-2 text-sm text-gray-500">
                  {TEXT.noResults}
                </div>
              )}

              {filteredPages.map((page, i) => (
                <button
                  key={i}
                  onClick={() => {
                    navigate(page.path);
                    setSearch("");
                  }}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                >
                  {page.name[lang] || page.name.EN}
                </button>
              ))}
            </div>
          )}
        </div>
          </div>
  )}
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-3">

        {/* LANGUAGE */}
        <button
          onClick={toggleLanguage}
          className="flex items-center gap-2 px-3 py-[5px] bg-[#2c2c2c] border border-[#3a3a3a] rounded-md text-sm hover:bg-[#363636]"
        >
          <FaGlobe />
          {lang}
        </button>

        {/* BELL */}
        <div className="relative" ref={bellRef}>

<button
  onClick={() => setBellOpen(!bellOpen)}
  className="relative p-2 rounded-md bg-[#2c2c2c] border border-[#3a3a3a] hover:bg-[#363636]"
>
  <FaBell />

  {totalNotifications > 0 && (
    <span className="
      absolute -top-1 -right-1
      min-w-[18px] h-[18px]
      px-1
      rounded-full
      bg-[#d72c0d] text-white
      text-[10px]
      flex items-center justify-center
      font-semibold
    ">
      {totalNotifications}
    </span>
  )}
</button>

{bellOpen && (
  <div
  className={`
  absolute mt-2 w-72
  ${lang === "AR" ? "left-0" : "right-0"}
  bg-white text-[#202223]
  rounded-xl
  shadow-[0_8px_24px_rgba(0,0,0,0.15)]
  border border-[#e1e3e5]
  overflow-hidden
  animate-fadeSlide
`}
>

    {/* HEADER */}

    <div className="px-4 py-[11px] border-b border-[#e1e3e5] font-semibold text-sm flex items-center gap-2">
      <FaBell className="text-gray-500" />
      {TEXT.notifications}
    </div>

    {/* ORDERS */}

    <button
      onClick={() => {
        navigate("/admin/orders");
        setBellOpen(false);
      }}
      className="
      w-full flex items-center justify-between
      px-4 py-[11px]
      text-sm
      hover:bg-[#f1f2f3]
      transition
      "
    >
      <div className="flex items-center gap-3">
        <FaShoppingCart className="text-gray-500" />
        {TEXT.orders}
      </div>

      {pendingOrders > 0 && (
  <span
    className="
    min-w-[20px] h-[20px]
    px-1
    rounded-full
    bg-[#d72c0d] text-white
    text-[11px]
    flex items-center justify-center
    font-semibold
    "
  >
    {pendingOrders}
  </span>
)}
    </button>

    {/* STOCK */}

    <button
      onClick={() => {
        navigate("/admin/inventory");
        setBellOpen(false);
      }}
      className="
      w-full flex items-center justify-between
      px-4 py-[11px]
      text-sm
      hover:bg-[#f1f2f3]
      transition
      "
    >
      <div className="flex items-center gap-3">
        <FaBoxOpen className="text-gray-500" />
        {TEXT.stock}
      </div>

      {notificationCounts.stock > 0 && (
        <span className="
        min-w-[20px] h-[20px]
        px-1
        rounded-full
        bg-[#d72c0d] text-white
        text-[11px]
        flex items-center justify-center
        font-semibold
        ">
          {notificationCounts.stock}
        </span>
      )}
    </button>

    {/* MESSAGES */}

    <button
      onClick={() => {
        navigate("/admin/messages");
        setBellOpen(false);
      }}
      className="
      w-full flex items-center justify-between
      px-4 py-[11px]
      text-sm
      hover:bg-[#f1f2f3]
      transition
      "
    >
      <div className="flex items-center gap-3">
        <FaEnvelope className="text-gray-500" />
        {TEXT.messages}
      </div>

      {notificationCounts.message > 0 && (
        <span className="
        min-w-[20px] h-[20px]
        px-1
        rounded-full
        bg-[#d72c0d] text-white
        text-[11px]
        flex items-center justify-center
        font-semibold
        ">
          {notificationCounts.message}
        </span>
      )}
    </button>

    {/* FOOTER */}

    <div className="border-t border-[#e1e3e5]">

      <button
        onClick={() => {
          navigate("/admin/notifications");
          setBellOpen(false);
        }}
        className="
        w-full
        px-4 py-[11px]
        text-sm
        text-[#008060]
        font-medium
        hover:bg-[#f1f2f3]
        transition
        "
      >
        {TEXT.viewAll}
      </button>

    </div>

  </div>
)}
</div>
        {/* PROFILE */}
        <div className="relative" ref={profileRef}>

          <button
            onClick={() => setProfileOpen(!profileOpen)}
            className="flex items-center gap-2 px-2 sm:px-3 py-[5px] bg-[#2c2c2c] border border-[#3a3a3a] rounded-md text-sm hover:bg-[#363636]"
          >
            <div className="w-6 h-6 rounded-full bg-gray-600 flex items-center justify-center text-xs font-bold">
              {avatarInitial}
            </div>

            {/* Hide name on mobile */}
            <span className="hidden sm:block">{username}</span>
          </button>

          {profileOpen && (
  <div
  className={`
    absolute mt-2 w-64 max-w-[90vw]
    ${lang === "AR" ? "left-0" : "right-0"}
    sm:max-w-none
      bg-white text-black
      rounded-lg
      shadow-lg
      border border-gray-200
      p-4
    `}
  >
              {/* Username */}
              <div className="text-sm mb-2">
                <span className="font-semibold">{TEXT.username}: </span>
                {username}
              </div>

              {/* Role */}
              <div className="text-sm mb-3">
                <span className="font-semibold">{TEXT.role}: </span>
                {role === "admin" ? TEXT.admin : TEXT.staff}
              </div>

              <div className="border-t pt-3">

                <button
                  onClick={logout}
                  className="flex items-center gap-2 text-red-600 hover:text-red-700 text-sm"
                >
                  <FaSignOutAlt />
                  {TEXT.logout}
                </button>

              </div>

            </div>
          )}

        </div>
      </div>
    </header>
<AdminCommandPalette
  open={commandOpen}
  setOpen={setCommandOpen}
  pages={pages}
  lang={lang}
/>
</>
  );
}

export default AdminHeader;